<template>
  <ProjectFeature class="mls-feature" left-background-image="/assets/mls/mls-bg.jpg" right-background-color="#003366" left-border-right="6px solid white">
    <template #left-header>
      <div class="feature-logo">
        <h2>
          A Connected Workplace
          <br />
          for Major League Soccer
        </h2>
      </div>
    </template>

    <template #left-body>
      <div class="feature-list">
        <ul>
          <li>
            <b>Zenapptic</b>
            delivered a connected digital experience for MLS's new Global Headquarters
          </li>
          <li>We unified digital experiences across lobbies, meeting spaces, and specialty displays</li>
          <li>We enabled real-time communications, live data, and seamless operations through a single Experience Management Platform (XMS)</li>
        </ul>
      </div>
    </template>

    <template #left-footer>
      <div class="mls-logo">
        <img src="/assets/mls/mls-logo.png" alt="Major League Soccer Logo" />
      </div>
    </template>

    <template #right-media>
      <div class="video-container">
        <ProjectFeatureMedia class="mls-video-player" :video-url="`${useCdnUrl()}/assets/mls/mls-preview.webm`" placeholder-text="Watch the video" :poster="`${useCdnUrl()}/assets/mls/mls-video-panel.jpg`">
          <img class="video-preview" :src="`${useCdnUrl()}/assets/mls/mls-video-panel.jpg`" alt="Major League Soccer livestream experience video preview" />
        </ProjectFeatureMedia>
      </div>
    </template>
  </ProjectFeature>
</template>

<style lang="scss">
.mls-feature {
  .project-feature__left {
    gap: 3rem;
    padding-bottom: 2rem;
    padding-top: 2rem;

    @media (max-width: 1024px) {
      padding-bottom: 5rem;
    }

    @media (max-width: 767px) {
      border-width: 0;
      gap: 1rem;
    }
  }

  .project-feature__right {
    @media (max-width: 1024px) {
      overflow: visible;
    }
  }

  .feature-logo {
    padding: 5rem 0 0;

    @media (max-width: 767px) {
      padding: 2rem 0 0;
    }

    h2 {
      color: white;
      font-size: 6.5rem;
      font-weight: 600;
      letter-spacing: -0.03em;
      line-height: 1;
      margin: 0;
    }
  }

  .feature-list {
    @media (max-width: 767px) {
      padding: 2rem 0;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 3rem;
      margin-left: -1rem;

      li {
        line-height: 1;
      }
    }
  }

  .mls-logo {
    text-align: right;

    @media (max-width: 767px) {
      text-align: center;
    }
  }

  .video-container {
    flex: 1 1 auto;
    height: auto;
    max-width: 100%;
    min-height: 0;
    position: relative;

    .mls-video-player {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-placeholder {
      height: 100%;
      max-width: none;
      width: 100%;
    }

    .video-preview {
      display: block;
      height: 100%;
      min-height: 0;
      object-fit: cover;
      pointer-events: none;
      width: 100%;
    }
  }
}
</style>
